import { useCallback } from 'react';
import { useAutomationRuleActions } from '../use-actions';
import { ActionItemType, EditWorkItemActionType } from '../types';

interface Props {
  actionId: string;
}

export function useEditWorkItemRelationship(props: Props) {
	const {setActions, actions} = useAutomationRuleActions();

	const onOptionsSelect = useCallback((value: string) => {
		setActions(oldActions => {
			const currentAction = oldActions.find(action => action.id === props.actionId) as ActionItemType;
			const others = oldActions.filter(action => action.id !== props.actionId);

			return [
				...others,
				{
					...currentAction,
					editWorkItem: {
						...currentAction.editWorkItem as EditWorkItemActionType,
						relationship: value,
					},
				},
			];
		});
	}, [props.actionId, actions]);

	return {
		onOptionsSelect,
	};
}